module.exports = __webpack_public_path__ + "img/45.1d5e0644.jpg";